'use client';

import type { HTMLAttributes } from 'react';

import { cn } from '../../utils/cva';

type SkeletonProps = {
  variant?: 'text' | 'rectangular' | 'circular';
  width?: number | string;
  height?: number | string;
  className?: string;
};

type Props = HTMLAttributes<HTMLDivElement> & SkeletonProps;

export const Skeleton = (props: Props) => {
  const { variant = 'rectangular', width, height, className } = props;
  return (
    <div
      role="progressbar"
      style={{
        width: width ? (typeof width === 'string' ? width : `${width}rem`) : '100%',
        height:
          variant === 'text'
            ? (height ?? '0.8rem')
            : height
              ? typeof height === 'string'
                ? height
                : `${height}rem`
              : '100%',
      }}
      className={cn(
        'bg-grey6 relative animate-pulse overflow-hidden',
        variant === 'rectangular' ? 'rounded-sm' : 'rounded-full',
        className,
      )}
    />
  );
};
